import { Business, BusinessSubscription } from "lens-platform-sdk";

export interface ActivationLinkInvitation {
  id: string;
  subscriptionId: string;
  link: string;
  createdAt: string;
  subscription: BusinessSubscription | null | undefined;
}

export const getActivationLinkInvitation = (
  business: Business,
  businessSubscriptions: BusinessSubscription[],
): ActivationLinkInvitation | null => {
  const businessIdLiteSubscription = businessSubscriptions.find(
    (subscription) =>
      subscription.shortSubscriptionId === business.businessIdLiteSubscriptionId ||
      subscription.id === business.businessIdLiteSubscriptionId,
  );

  if (!businessIdLiteSubscription) {
    return null;
  }

  return {
    createdAt: business.createdAt,
    subscriptionId: businessIdLiteSubscription.id,
    id: businessIdLiteSubscription.id,
    subscription: businessIdLiteSubscription,
    link: `${window.location.origin}/home/activate?subscriptionId=${businessIdLiteSubscription.id}&planName=${businessIdLiteSubscription.planName}&planCode=${businessIdLiteSubscription.planCode}&company=${business.name}`,
  };
};
